import React from "react";
import { Link } from "react-router-dom";

interface InnerBannerProps {
  pageName: string;
}

const InnerBanner: React.FC<InnerBannerProps> = ({ pageName }) => {
  return (
    <section
      style={{
        position: "relative",
        height: "72px",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",

        background: "#000000",

        borderBottom: "1px solid rgba(0,246,255,0.18)",

        boxShadow: "0 6px 20px rgba(0,0,0,0.8)",
      }}
    >
      {/* =========================
          SUBTLE GRID
      ========================= */}

      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",

          opacity: 0.06,

          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",

          backgroundSize: "34px 34px",
        }}
      />

      {/* =========================
          CYAN GLOW
      ========================= */}

      <div
        style={{
          position: "absolute",

          width: "180px",
          height: "180px",

          left: "-120px",
          top: "-80px",

          borderRadius: "50%",

          background: "rgba(0,246,255,0.035)",

          filter: "blur(80px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          PURPLE GLOW
      ========================= */}

      <div
        style={{
          position: "absolute",

          width: "180px",
          height: "180px",

          right: "-120px",
          top: "-80px",

          borderRadius: "50%",

          background: "rgba(139,92,255,0.035)",

          filter: "blur(80px)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          CONTENT
      ========================= */}

      <div
        className="container"
        style={{
          position: "relative",
          zIndex: 2,
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            width: "100%",
          }}
        >
          {/* =========================
              LEFT — TITLE
          ========================= */}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              minWidth: 0,
            }}
          >
            {/* GROWNIVERSE */}

            <span
              style={{
                color: "#00f6ff",

                fontSize: "8px",

                fontWeight: 700,

                letterSpacing: "1.8px",

                textTransform: "uppercase",

                padding: "4px 8px",

                border: "1px solid rgba(0,246,255,0.20)",

                borderRadius: "3px",

                background: "rgba(0,246,255,0.025)",

                whiteSpace: "nowrap",
              }}
            >
              GROWNIVERSE
            </span>

            {/* VERTICAL DIVIDER */}

            <span
              style={{
                width: "1px",
                height: "20px",

                background:
                  "linear-gradient(transparent, rgba(0,246,255,0.6), transparent)",

                flexShrink: 0,
              }}
            />

            {/* PAGE NAME */}

            <h1
              style={{
                margin: 0,

                color: "#ffffff",

                fontSize: "clamp(18px, 2.2vw, 25px)",

                fontWeight: 800,

                letterSpacing: "-0.3px",

                lineHeight: 1,

                whiteSpace: "nowrap",

                overflow: "hidden",

                textOverflow: "ellipsis",

                textShadow:
                  "0 0 15px rgba(255,255,255,0.07)",
              }}
            >
              {pageName}
            </h1>

            {/* SMALL CYAN LINE */}

            <span
              style={{
                width: "30px",
                height: "2px",

                background:
                  "linear-gradient(90deg, #00f6ff, transparent)",

                boxShadow:
                  "0 0 7px rgba(0,246,255,0.6)",

                flexShrink: 0,
              }}
            />
          </div>

          {/* =========================
              RIGHT — BREADCRUMB
          ========================= */}

          <div
            style={{
              display: "flex",

              alignItems: "center",

              gap: "7px",

              fontSize: "11px",

              fontWeight: 600,

              flexShrink: 0,
            }}
          >
            {/* HOME */}

            <Link
              to="/"
              style={{
                display: "inline-flex",

                alignItems: "center",

                gap: "5px",

                color: "#7f8a9a",

                textDecoration: "none",

                transition: "color 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = "#00f6ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = "#7f8a9a";
              }}
            >
              <i
                className="fas fa-home"
                style={{
                  fontSize: "10px",
                }}
              />

              Home
            </Link>

            {/* SEPARATOR */}

            <span
              style={{
                color: "#00f6ff",

                opacity: 0.6,
              }}
            >
              /
            </span>

            {/* CURRENT PAGE */}

            <span
              style={{
                color: "#ffffff",

                padding: "4px 8px",

                border:
                  "1px solid rgba(255,255,255,0.08)",

                borderRadius: "3px",

                background: "rgba(255,255,255,0.025)",

                whiteSpace: "nowrap",
              }}
            >
              {pageName}
            </span>
          </div>
        </div>
      </div>

      {/* =========================
          BOTTOM SCAN LINE
      ========================= */}

      <div
        style={{
          position: "absolute",

          bottom: 0,

          left: "15%",
          right: "15%",

          height: "1px",

          background:
            "linear-gradient(90deg, transparent, rgba(0,246,255,0.55), transparent)",

          boxShadow:
            "0 0 8px rgba(0,246,255,0.35)",

          pointerEvents: "none",
        }}
      />

      {/* =========================
          CORNER ACCENTS
      ========================= */}

      <div
        style={{
          position: "absolute",

          left: "15px",
          bottom: "8px",

          width: "22px",
          height: "1px",

          background: "#00f6ff",

          opacity: 0.4,
        }}
      />

      <div
        style={{
          position: "absolute",

          right: "15px",
          bottom: "8px",

          width: "22px",
          height: "1px",

          background: "#8b5cff",

          opacity: 0.4,
        }}
      />

      {/* =========================
          MOBILE
      ========================= */}

      <style>
        {`
          @media (max-width: 768px) {
            section {
              height: 60px !important;
            }

            section .container > div {
              gap: 10px !important;
            }

            section h1 {
              font-size: 18px !important;
            }

            section h1 + span {
              display: none;
            }

            section [style*="GROWNIVERSE"] {
              font-size: 7px !important;
              padding: 3px 6px !important;
            }

            section .fa-home {
              display: none;
            }
          }

          @media (max-width: 500px) {
            section {
              height: 55px !important;
            }

            section .container {
              padding-left: 12px !important;
              padding-right: 12px !important;
            }

            section h1 {
              font-size: 16px !important;
            }

            section .container > div {
              gap: 7px !important;
            }

            section [style*="GROWNIVERSE"] {
              display: none;
            }

            section [style*="Home"] {
              font-size: 10px !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default InnerBanner;